msgid ""
msgstr ""
"POT-Creation-Date: 2026-03-09 13:54+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: nb_NO\n"
"Project-Id-Version: 840277a61c48b2d4cf2608de8cdc6590\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Norwegian Bokmal\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 840277a61c48b2d4cf2608de8cdc6590\n"
"X-Crowdin-Project-ID: 600\n"
"X-Crowdin-Language: nb\n"
"X-Crowdin-File-ID: 30229\n"
"PO-Revision-Date: \n"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:44
msgid " will use "
msgstr " vil bruke "

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:45
msgid "'s company profile."
msgstr " sin bedriftsprofil."

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:32
msgid "(Optional)"
msgstr "(Valgfritt)"

#. placeholder {0}: newFollowers ?? 0
#: src/client/components/StatisticsModal/StatisticsSummary.tsx:26
msgid "{0, plural, one {New follower} other {New followers}}"
msgstr "{0, plural, one {Ny følger} other {Nye følgere}}"

#. placeholder {0}: totalFollowers ?? 0
#: src/client/components/StatisticsModal/StatisticsSummary.tsx:19
msgid "{0, plural, one {Total follower} other {Total followers}}"
msgstr "{0, plural, one {Følger totalt} other {Følgere totalt}}"

#. placeholder {0}: modalContent[type].title
#: src/client/components/ImageEditor/ImageEditorModal.tsx:122
msgid "{0}"
msgstr "{0}"

#. placeholder {0}: MAX_TEXT_LENGTH - description.length
#. placeholder {0}: MAX_TEXT_LENGTH - text.length
#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:102
#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:113
msgid "{0} characters remaining"
msgstr "{0} tegn igjen"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:59
msgid "{childName} will get their own company profile."
msgstr "{childName} vil få sin egen bedriftsprofil."

#. js-lingui-explicit-id
#: src/client/components/StatisticsModal/statisticsChartOptions.ts:12
msgid "statistics.newFollowers"
msgstr "{count, plural, one {ny følger} other {nye følgere}}"

#. js-lingui-explicit-id
#: src/client/components/StatisticsModal/statisticsChartOptions.ts:18
msgid "statistics.uniqueViews"
msgstr "{count, plural, one {ny besøkende} other {nye besøkende}}"

#. js-lingui-explicit-id
#: src/server/renderProfilePage.ts:62
msgid "page.title.seekers"
msgstr "{displayName} profil og ledige stillinger | FINN jobb"

#. js-lingui-explicit-id
#: src/server/renderProfilePage.ts:77
msgid "og.title"
msgstr "Et blikk på innsiden av {displayName}"

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:76
msgid "Activated"
msgstr "Aktivert"

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:33
msgid "Add at least one link"
msgstr "Legg til minst én lenke"

#: src/client/components/CompanyDetails/Description/Description.tsx:79
msgid "Add description"
msgstr "Legg til beskrivelse"

#: src/client/components/AmbassadorsSection/AmbassadorEditMode.tsx:70
msgid "Add employee"
msgstr "Legg til medarbeider"

#: src/client/components/TopImage/EmptyTopImage.tsx:19
msgid "Add header image (980 x 375px)"
msgstr "Legg til toppbilde (980 x 375px)"

#: src/client/components/CompanyDetails/HomepageLink/HomepageLink.tsx:39
msgid "Add homepage"
msgstr "Legg til hjemmeside"

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditGallery.tsx:189
msgid "Add images"
msgstr "Legg til bilder"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:175
msgid "Add link"
msgstr "Legg til lenke"

#: src/client/components/VideosSection/AddVideoField.tsx:36
msgid "Add link to a video from YouTube or Vimeo"
msgstr "Legg inn lenke til en video fra YouTube eller Vimeo"

#: src/client/components/AddSectionButton/AddSectionButton.tsx:105
msgid "Add section"
msgstr "Legg til seksjon"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:58
msgid "Add sections"
msgstr "Legg til seksjoner"

#: src/client/components/AddSectionButton/AddSectionButton.tsx:92
msgid "Add sections with images and other content"
msgstr "Legg til seksjoner med bilder og annet innhold"

#: src/client/components/VideosSection/AddVideoField.tsx:48
msgid "Add video"
msgstr "Legg til video"

#: src/client/components/ImageEditor/ImageEditorModal.tsx:121
msgid "Adjust and crop "
msgstr "Tilpass og beskjær "

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:60
msgid "Ads link to own company profile"
msgstr "Annonser lenker til egen bedriftsprofil"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:50
msgid "Ads link to this company profile"
msgstr "Annonser lenker til denne bedriftsprofilen"

#: src/client/components/Hierarchy/HierarchyFilter.tsx:51
msgid "All"
msgstr "Alle"

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:27
msgid "All positions in one place"
msgstr "Alle stillinger samlet"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:132
msgid "Back"
msgstr "Tilbake"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:111
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:40
msgid "Background color"
msgstr "Bakgrunnsfarge"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:108
msgid "Background color is required"
msgstr "Bakgrunnsfarge er påkrevd"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:101
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:91
msgid "Brand"
msgstr "Merkevare"

#: src/client/components/CompanyDetails/Description/DescriptionEdit.tsx:35
msgid "Briefly describe who you are, what you do - and why people should join your team."
msgstr "Fortell kort hvem dere er, hva dere gjør - og hvorfor folk burde jobbe hos dere. "

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:53
msgid "But that doesn't mean there are no opportunities!"
msgstr "Men det betyr ikke at det ikke finnes muligheter!"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:124
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:49
msgid "Button color"
msgstr "Farge på knapp"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:121
msgid "Button color is required"
msgstr "Knappefarge er påkrevd"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:58
msgid "By removing the connection, {childName} will stop using {motherName}'s company profile."
msgstr "Ved å fjerne tilknytningen, vil {childName} slutte å bruke {motherName} sin bedriftsprofil."

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:210
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:111
#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:69
#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:121
msgid "Cancel"
msgstr "Avbryt"

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:28
msgid "Candidates easily find other relevant jobs at your company."
msgstr "Kandidater finner lett andre relevante jobber hos dere."

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:23
msgid "Candidates who follow the company automatically receive a message when new ads are published. Increased reach without extra work."
msgstr "Kandidater som følger bedriften får automatisk melding når nye annonser blir publisert. Økt rekkevidde uten ekstra arbeid."

#: src/client/components/Onboarding/OnboardingEditModal.tsx:63
msgid "Change order"
msgstr "Endre rekkefølge"

#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:48
#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:67
msgid "Changes saved"
msgstr "Endringene er lagret"

#: src/client/components/LimitedTextField.tsx:13
msgid "Character limit reached"
msgstr "Maks antall tegn er nådd"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:190
msgid "Choose one link to use as the main button in the card"
msgstr "Velg én lenke å bruke som hovedknapp i kortet"

#: src/client/components/ImagesSection/ImagesPreview.tsx:43
#: src/client/components/Onboarding/OnboardingEditorModal.tsx:55
#: src/client/components/SectionToolbar/SectionToolbar.tsx:50
msgid "Close"
msgstr "Lukk"

#: src/client/components/SectionToolbar/SectionToolbar.tsx:49
msgid "Close section"
msgstr "Lukk seksjon"

#: src/client/components/CompanyDetails/Description/DescriptionEdit.tsx:34
msgid "Company information"
msgstr "Informasjon om firma"

#: src/client/components/Hierarchy/HierarchyTable.tsx:41
msgid "Company name"
msgstr "Firmanavn"

#: src/client/components/ProfileToolbar/PreviewModeSwitch.tsx:35
#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:63
#: src/islands/hierarchyPage/Hierarchy.tsx:25
msgid "Company profile"
msgstr "Bedriftsprofil"

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:62
msgid "Company profile – this is what candidates see"
msgstr "Bedriftsprofilen – dette ser kandidatene"

#. js-lingui-explicit-id
#: src/server/renderExtendedProfilePage.ts:57
#: src/server/renderHierarchyPage.ts:55
#: src/server/renderProfilePage.ts:67
#: src/server/renderProfilePage.ts:71
msgid "page.title.recruiters"
msgstr "Bedriftsprofiler - FINN jobb"

#: src/client/components/Hierarchy/HierarchyFilter.tsx:57
#: src/client/components/Hierarchy/HierarchyRow.tsx:42
msgid "Connected"
msgstr "Tilknyttet"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:54
msgid "Connection created"
msgstr "Tilknytning opprettet"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:62
msgid "Connection removed"
msgstr "Tilknytning fjernet"

#: src/client/components/ProfileToolbar/Toolbar.tsx:21
#: src/islands/hierarchyPage/Hierarchy.tsx:28
msgid "Connections"
msgstr "Tilknytninger"

#: src/client/components/Hierarchy/HierarchyContent.tsx:72
msgid "Contact <0>jobb.finn@vend.com</0> if an organization is missing."
msgstr "Ta kontakt med <0>jobb.finn@vend.com</0> dersom det mangler en organisasjon."

#: src/client/components/EmptyMessage.tsx:28
msgid "Contact <0>jobb.finn@vend.com</0> if this needs to be updated."
msgstr "Ta kontakt med <0>jobb.finn@vend.com</0> dersom dette skal oppdateres."

#: src/client/components/ProfileContent.tsx:104
msgid "Contact the owner of this company profile if you want to disconnect it and use your own company profile and brand."
msgstr "Ta kontakt med eieren av denne bedriftsprofilen dersom du ønsker å koble den fra og bruke din egen bedriftsprofil og merkevare."

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:27
msgid "Continue editing"
msgstr "Fortsett å redigere"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:83
msgid "Could not publish. Please try again later."
msgstr "Kunne ikke publisere. Prøv igjen senere."

#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:49
#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:68
#: src/client/components/ExtendedProfileForm/ExtendedProfileContent.tsx:74
msgid "Could not save. Please try again later."
msgstr "Kunne ikke lagre. Prøv igjen senere."

#: src/client/components/Hierarchy/HierarchyRow.tsx:100
msgid "Create connection"
msgstr "Opprett tilknytning"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:39
msgid "Create connection to {childName}?"
msgstr "Opprett tilknytning til {childName}?"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:139
#: src/client/components/SectionToolbar/SectionToolbar.tsx:85
msgid "Delete"
msgstr "Slett"

#: src/client/components/ImageEditor/ImageCropper.tsx:229
#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:160
msgid "Delete image"
msgstr "Slett bilde"

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:67
msgid "Delete link"
msgstr "Slett lenke"

#: src/client/components/SectionToolbar/SectionToolbar.tsx:84
msgid "Delete section"
msgstr "Slett seksjon"

#: src/client/components/VideosSection/VideoField.tsx:44
msgid "Delete video"
msgstr "Slett video"

#: src/client/components/VideosSection/VideoField.tsx:30
msgid "Description"
msgstr "Beskrivelse"

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:24
#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:153
msgid "Discard changes and leave page"
msgstr "Forkast endringer og forlat siden"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:141
msgid "Displayed at the top of the profile card"
msgstr "Vises øverst i profilkortet"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:140
msgid "Do you want to leave without publishing?"
msgstr "Vil du forlate uten å publisere?"

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:18
msgid "Do you want to leave without saving changes?"
msgstr "Vil du forlate uten å lagre endringene?"

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:21
msgid "Do you want to show Extended Profile on job ads for this company?"
msgstr "Ønsker du å vise Tydelig Profil på stillingsannonsene til denne bedriften?"

#: src/client/components/ImageEditor/DropZone.tsx:37
msgid "Drag and drop, or click to upload"
msgstr "Dra og slipp, eller klikk for å laste opp"

#: src/client/components/AmbassadorsSection/AmbassadorLogo.tsx:90
#: src/client/components/ProfileToolbar/Toolbar.tsx:58
#: src/client/components/SectionToolbar/SectionToolbar.tsx:50
msgid "Edit"
msgstr "Rediger"

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:63
#: src/client/components/Onboarding/OnboardingEditorTip.tsx:17
msgid "Edit company profile"
msgstr "Rediger bedriftsprofilen"

#: src/client/components/TopImage/FilledTopImage.tsx:36
msgid "Edit header image"
msgstr "Rediger toppbilde"

#: src/client/components/SectionToolbar/SectionToolbar.tsx:49
msgid "Edit section"
msgstr "Rediger seksjon"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:103
msgid "Editing company profile"
msgstr "Rediger bedriftsprofil"

#: src/client/components/AddSectionButton/AddSectionButton.tsx:57
msgid "Employees"
msgstr "Medarbeidere"

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:66
#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:73
msgid "Extended profile"
msgstr "Tydelig profil"

#: src/client/components/ProfileToolbar/Toolbar.tsx:33
msgid "Extended Profile"
msgstr "Tydelig Profil"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:51
msgid "Extended Profile is shared with the main organization (if activated)"
msgstr "Tydelig Profil deles med hovedorganisasjonen (hvis aktivert)"

#: src/client/components/EmptyMessage.tsx:35
msgid "Extended profile must be set up by the main account before you can use it. Once"
msgstr "Tydelig profil må settes opp av hovedkonto før dere kan bruke den. Når det"

#: src/client/components/ImageUploader.tsx:36
msgid "File is too large (max {FILE_SIZE_IN_MB}MB)"
msgstr "Filen er for stor (maks {FILE_SIZE_IN_MB}MB)"

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:36
#: src/client/components/ExtendedProfileForm/LinkRow.tsx:56
msgid "Fill in both fields"
msgstr "Fyll ut begge feltene"

#. js-lingui-explicit-id
#: src/server/renderProfilePage.ts:84
msgid "og.site_name"
msgstr "FINN.no Bedriftsprofiler"

#: src/client/components/CompanyDetails/CompanyDetails.tsx:80
msgid "follower"
msgstr "følger"

#: src/client/components/ProfileToolbar/Toolbar.tsx:24
msgid "Follower statistics"
msgstr "Følgerstatistikk"

#: src/client/components/CompanyDetails/CompanyDetails.tsx:80
msgid "followers"
msgstr "følgere"

#: src/client/components/StatisticsModal/StatisticsModal.tsx:33
msgid "Followers"
msgstr "Følgere"

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:22
msgid "Followers get notified about new positions"
msgstr "Følgere får varsel om nye stillinger"

#: src/client/components/CompanyDetails/FollowButton.tsx:31
msgid "Following"
msgstr "Følger"

#: src/client/components/ImageEditor/LogoCheck.tsx:39
msgid "For best results, the logo should be at least {IMAGE_MIN_SIZE}x{IMAGE_MIN_SIZE} pixels. Currently it is"
msgstr "For best resultat bør logoen være minst {IMAGE_MIN_SIZE}X{IMAGE_MIN_SIZE} piksler. Nå er den"

#: src/client/components/ImageEditor/LogoCheck.tsx:97
msgid "For best results, use a square logo (1:1) that is at least {IMAGE_MIN_SIZE} x {IMAGE_MIN_SIZE} pixels, with a colored background."
msgstr "For best resultat, bruk en firkantet logo (1:1) som er minst {IMAGE_MIN_SIZE} x {IMAGE_MIN_SIZE} piksler, med farget bakgrunn."

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:48
msgid "Get more out of your job ads by tagging images with job function in the company profile. Then the right image is shown in the right ad."
msgstr "Få mer ut av stillingsannonsene dine ved å tagge bilder med stillingsfunksjon i bedriftsprofilen. Da vises riktig bilde i riktig annonse."

#: src/client/components/CompanyDetails/FollowButton.tsx:31
msgid "Get notified about new positions"
msgstr "Bli varslet om nye stillinger"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:65
msgid "Get started"
msgstr "Kom i gang"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:44
msgid "Get the most out of your company profile"
msgstr "Få mest mulig ut av bedriftsprofilen"

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:81
msgid "Give your ads an extra boost with a dedicated section that highlights your brand — with custom colors, heading and links."
msgstr "Gi annonsene et ekstra løft med en egen seksjon som fremhever merkevaren din — med egne farger, overskrift og lenker."

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:38
msgid "Go to ad overview"
msgstr "Til annonseoversikt"

#: src/client/components/ImageEditor/ImageEditorModal.tsx:62
msgid "header image"
msgstr "toppbilde"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:140
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:59
msgid "Heading"
msgstr "Overskrift"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:137
msgid "Heading is required"
msgstr "Overskrift er påkrevd"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:154
msgid "Here you can add links that show who you are – for example career page or social media; candidates often check this type of content before applying for positions."
msgstr "Her kan du legge til lenker som viser hvem dere er – for eksempel karriereside eller sosiale medier; kandidater sjekker ofte denne type innhold før de søker på stillinger."

#: src/islands/hierarchyPage/Hierarchy.tsx:36
msgid "Here you can connect organizations that will share company profile, logo and brand."
msgstr "Her kan du koble til organisasjoner som skal dele bedriftsprofil, logo og merkevare."

#: src/client/components/CompanyDetails/HomepageLink/HomepageLinkEdit.tsx:44
msgid "Homepage"
msgstr "Hjemmeside"

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:55
msgid "If you don't tag any images, the first image in the image gallery will be used."
msgstr "Hvis du ikke tagger noen bilder, blir det første bildet i bildegalleriet brukt."

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:33
msgid "If you tag the images with job functions, they are automatically used in online newspapers and social media when you buy Pluss."
msgstr "Tagger du bildene med stillingsfunksjoner, brukes de automatisk i nettaviser og sosiale medier når du kjøper Pluss."

#: src/client/components/ImageEditor/ImageEditorModal.tsx:70
msgid "image"
msgstr "bilde"

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:94
msgid "Image caption"
msgstr "Bildetekst"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:59
msgid "Image is required"
msgstr "Bilde er påkrevd"

#: src/client/components/AddSectionButton/AddSectionButton.tsx:31
msgid "Images"
msgstr "Bilder"

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:43
msgid "Images are automatically fetched from your Company profile"
msgstr "Bilder hentes automatisk fra Bedriftsprofilen din"

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:47
msgid "Images tagged with job function are prioritized. If no images are tagged, the first image from the image gallery in the company profile is used."
msgstr "Bilder tagget med stillingsfunksjon prioriteres. Dersom ingen bilder er tagget, brukes første bilde fra bildegalleriet i bedriftsprofilen."

#: src/islands/extendedProfilePage/ExtendedProfilePage.tsx:76
msgid "Inactive"
msgstr "Inaktiv"

#: src/client/components/ActiveAds/ActiveAds.tsx:42
msgid "Job openings"
msgstr "Ledige stillinger"

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:28
msgid "Job openings are what candidates look for first – that's why they are at the top of the company profile. Post an ad and show candidates what you're looking for!"
msgstr "Ledige stillinger er det kandidatene kikker etter først – derfor ligger de øverst på bedriftsprofilen. Legg ut en annonse og vis kandidatene hva dere ser etter!"

#: src/client/components/ActiveAds/EditModeActiveAds.tsx:16
msgid "Job openings are what matters most to candidates. That's why we show them at the top, so your dream candidate can easily find the jobs you've posted."
msgstr "Ledige stillinger er det viktigste for kandidatene. Derfor viser vi dem øverst, så drømmekandidaten enkelt finner jobbene dere har utlyst."

#: src/client/components/ActiveAds/ActiveAds.tsx:42
msgid "Job openings at {displayName}"
msgstr "Ledige stillinger hos {displayName}"

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:42
msgid "Link text"
msgstr "Lenketekst"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:150
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:68
msgid "Links"
msgstr "Lenker"

#: src/client/components/ImageEditor/ImageEditorModal.tsx:64
msgid "logo"
msgstr "logo"

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:186
msgid "Main button"
msgstr "Hovedknapp"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:54
msgid "Make it easier for candidates to recognize you. The logo is automatically used in all new ads."
msgstr "Gjør det enklere for kandidater å kjenne dere igjen. Logoen brukes automatisk i alle nye annonser."

#: src/islands/hierarchyPage/Hierarchy.tsx:33
msgid "Manage connected organizations"
msgstr "Administrer tilknyttede organisasjoner"

#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:102
msgid "Managed by {ownerName}"
msgstr "Administreres av {ownerName}"

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:122
msgid "More positions"
msgstr "Flere stillinger"

#: src/client/components/SectionToolbar/SectionToolbar.tsx:73
msgid "Move down"
msgstr "Flytt ned"

#: src/client/components/SectionToolbar/SectionToolbar.tsx:72
msgid "Move section down"
msgstr "Flytt seksjon ned"

#: src/client/components/SectionToolbar/SectionToolbar.tsx:60
msgid "Move section up"
msgstr "Flytt seksjon opp"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:64
msgid "Move sections up or down and decide what candidates see first. Highlight what's most important to you."
msgstr "Flytt seksjonene opp eller ned og bestem hva kandidatene skal se først. Fremhev det som er viktigst for dere."

#: src/client/components/SectionToolbar/SectionToolbar.tsx:61
msgid "Move up"
msgstr "Flytt opp"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:111
msgid "Name"
msgstr "Navn"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:108
msgid "Name is required"
msgstr "Navn er påkrevd"

#: src/client/components/StatisticsModal/StatisticsChart.tsx:65
msgid "New followers"
msgstr "Nye følgere"

#: src/client/components/StatisticsModal/StatisticsChart.tsx:56
msgid "New followers in the last 14 days"
msgstr "Nye følgere de siste 14 dagene"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:135
msgid "Next"
msgstr "Neste"

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:82
msgid "No images in the image gallery"
msgstr "Ingen bilder i bildegalleriet"

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:25
msgid "No job openings"
msgstr "Ingen ledige stillinger"

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:77
msgid "No, do not activate Extended Profile"
msgstr "Nei, ikke aktiver Tydelig Profil"

#: src/client/components/Hierarchy/HierarchyFilter.tsx:54
#: src/client/components/Hierarchy/HierarchyRow.tsx:42
msgid "Not connected"
msgstr "Ikke tilknyttet"

#: src/client/components/ActiveAds/ActiveAds.tsx:175
#: src/client/components/EmptyMessage.tsx:21
msgid "Nothing here!"
msgstr "Her var det tomt gitt!"

#: src/client/components/ImagesSection/ImagesPreview.tsx:47
msgid "of"
msgstr "av"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:60
msgid "Own profile, logo and text are used as default"
msgstr "Egen profil, logo og tekst brukes som standard"

#: src/client/components/AmbassadorsSection/AmbassadorsSection.tsx:49
#: src/client/components/ImagesSection/ImagesSection.tsx:51
msgid "Please correct the errors before exiting edit mode"
msgstr "Vennligst rett opp feilene før du avslutter redigeringsmodus"

#: src/client/components/VideosSection/AddVideoField.tsx:30
msgid "Please enter a valid YouTube or Vimeo link"
msgstr "Vennligst legg inn en gyldig YouTube- eller Vimeo-lenke"

#: src/client/components/EmptyMessage.tsx:23
msgid "Please try searching again."
msgstr "Vennligst prøv å søke på nytt."

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:164
#: src/client/components/ImageEditor/LogoCheck.tsx:65
msgid "Preview"
msgstr "Forhåndsvisning"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:49
msgid "Profile, logo and text are set as default"
msgstr "Profil, logo og tekst settes som standard"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:156
msgid "Publish changes"
msgstr "Publiser endringer"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:78
msgid "Published"
msgstr "Publisert"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:78
msgid "Quote"
msgstr "Sitat"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:75
msgid "Quote is required"
msgstr "Sitat er påkrevd"

#: src/client/components/AmbassadorsSection/AmbassadorCard.tsx:40
msgid "Read less"
msgstr "Les mindre"

#: src/client/components/AmbassadorsSection/AmbassadorCard.tsx:40
#: src/client/components/CompanyDetails/Description/Description.tsx:118
#: src/client/components/Onboarding/OnboardingEditorTip.tsx:27
msgid "Read more"
msgstr "Les mer"

#: src/client/components/ImageEditor/LogoCheck.tsx:94
msgid "Recommended format"
msgstr "Anbefalt format"

#: src/client/components/ImageEditor/ImageEditorModal.tsx:67
msgid "Recommended format: Square logo (1:1 ratio). PNG, JPEG or JPG. {IMAGE_MIN_SIZE}x{IMAGE_MIN_SIZE} pixels minimum."
msgstr "Anbefalt format: Kvadratisk logo (1:1-format). PNG, JPEG eller JPG. {IMAGE_MIN_SIZE}×{IMAGE_MIN_SIZE} piksler minimum."

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:44
msgid "Remember to choose images"
msgstr "Husk å velge bilder"

#: src/client/components/Hierarchy/HierarchyRow.tsx:89
msgid "Remove connection"
msgstr "Fjern tilknytning"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:57
msgid "Remove connection to {childName}?"
msgstr "Fjern tilknytning til {childName}?"

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:80
msgid "Removed from existing ads, and new ads will not get the product or be invoiced."
msgstr "Fjernes fra eksisterende annonser, og nye annonser vil ikke få produktet eller bli fakturert."

#: src/client/components/ExtendedProfileForm/ExtendedProfileForm.tsx:213
#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:114
#: src/client/components/ImageEditor/ImageEditorModal.tsx:135
msgid "Save"
msgstr "Lagre"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:131
msgid "Save and publish"
msgstr "Lagre og publiser"

#: src/client/components/Hierarchy/HierarchyFilter.tsx:37
msgid "Search"
msgstr "Søk"

#: src/client/components/ActiveAds/ActiveAds.tsx:132
msgid "Search for job title"
msgstr "Søk etter stillingstittel"

#: src/client/components/Hierarchy/HierarchyFilter.tsx:36
msgid "Search for sub-organization"
msgstr "Søk etter underorganisasjon"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:48
msgid "See how"
msgstr "Se hvordan"

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:129
msgid "Select position"
msgstr "Velg stilling"

#: src/client/components/AddSectionButton/AddSectionButton.tsx:90
msgid "Share more about your company"
msgstr "Del mer om dere"

#: src/client/components/ActiveAds/ActiveAds.tsx:167
msgid "Show more"
msgstr "Vis mer"

#: src/client/components/Onboarding/OnboardingEditorModal.tsx:32
msgid "Show what it's like to work at your company with images and video."
msgstr "Vis hvordan det er å jobbe hos dere med bilder og video."

#: src/client/components/Onboarding/OnboardingEditorTip.tsx:20
msgid "Showcase your company culture with images, information and quotes from employees. A professional profile attracts more qualified applicants."
msgstr "Vis frem bedriftskulturen med bilder, informasjon og sitat fra ansatte. En profesjonell profil tiltrekker flere kvalifiserte søkere."

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:52
msgid "Shown on all new ads and you will be invoiced NOK {extendedProfilePrice} extra per ad."
msgstr "Vises på alle nye annonser og du blir fakturert {extendedProfilePrice} kr ekstra per annonse."

#: src/client/components/Onboarding/OnboardingEditModal.tsx:47
msgid "Skip"
msgstr "Hopp over"

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:56
msgid "SmartSearch finds similar jobs – also from other companies you might like."
msgstr "SmartSøk finner jobber som ligner – også fra andre bedrifter du kan like."

#: src/client/components/AmbassadorsSection/AmbassadorsSection.tsx:105
msgid "Some of our employees"
msgstr "Noen av våre medarbeidere"

#: src/client/components/ImageUploader.tsx:56
msgid "Something went wrong"
msgstr "Noe gikk galt"

#: src/client/components/Hierarchy/HierarchyFilter.tsx:45
#: src/client/components/Hierarchy/HierarchyTable.tsx:44
msgid "Status"
msgstr "Status"

#: src/client/components/Hierarchy/HierarchyRow.tsx:67
msgid "sub-organizations"
msgstr "underorganisasjoner"

#: src/client/components/ImageEditor/DropZone.tsx:40
msgid "Supported file types: PNG, JPEG, JPG"
msgstr "Støttede filtyper: PNG, JPEG, JPG"

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:119
msgid "Tag image with positions"
msgstr "Tagg bildet med stillinger"

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:131
msgid "Tagged images are automatically used in campaigns for this position type."
msgstr "Taggede bilder brukes automatisk i kampanjer for denne stillingstypen."

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:94
msgid "Text"
msgstr "Tekst"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:90
#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:101
#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:101
#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:112
msgid "Text cannot be longer than {MAX_TEXT_LENGTH} characters"
msgstr "Teksten kan ikke være lenger enn {MAX_TEXT_LENGTH} tegn"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:87
msgid "Text is required"
msgstr "Tekst er påkrevd"

#: src/client/components/EmptyMessage.tsx:36
msgid "that is done, you can activate the extended profile here."
msgstr "er gjort, kan du aktivere tydelig profil her."

#: src/client/components/ExtendedProfileForm/ExtendedProfileInheritedView.tsx:95
msgid "The brand is centrally managed by {ownerName}. Contact the owner if you want your own company profile."
msgstr "Merkevaren styres sentralt av {ownerName}. Kontakt eier dersom du ønsker din egen bedriftsprofil."

#: src/client/components/ProfileContent.tsx:102
msgid "The company profile is centrally managed by "
msgstr "Bedriftsprofilen administreres sentralt av "

#: src/client/components/ImageEditor/LogoCheck.tsx:36
msgid "The logo could be sharper."
msgstr "Logoen kan bli skarpere."

#: src/client/components/ImageEditor/LogoCheck.tsx:68
msgid "The logo is displayed in job ads, in search results, on the company profile and when promoting in external channels."
msgstr "Logoen vises i stillingsannonser, i søkeresultatet, på bedriftsprofilen og ved profilering i eksterne kanaler."

#: src/client/components/ImageEditor/LogoCheck.tsx:50
msgid "The logo is within our recommendations."
msgstr "Logoen er innenfor anbefalingene våre."

#: src/client/components/Onboarding/OnboardingEditModal.tsx:59
msgid "The more sections you add, the more you can share – like images, videos and other exciting content that makes your profile shine."
msgstr "Jo flere seksjoner du legger til, jo mer kan du dele – som bilder, videoer og annet spennende innhold som får profilen til å skinne."

#: src/client/components/ExtendedProfileForm/Preview/CardPreview.tsx:63
msgid "The preview updates when you add content"
msgstr "Forhåndsvisningen oppdateres når du legger til innhold"

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:47
msgid "There are currently no job openings at "
msgstr "Det er for tiden ingen ledige stillinger hos "

#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:74
#: src/client/components/ExtendedProfileForm/Preview/ExtendedProfilePreview.tsx:92
msgid "This is how Extended Profile appears in your ads"
msgstr "Slik vises Tydelig Profil i annonsene deres"

#: src/client/components/EmptyMessage.tsx:26
msgid "This organization has no sub-companies that can be connected"
msgstr "Denne organisasjonen har ingen underselskaper som kan kobles til"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:120
msgid "This will happen:"
msgstr "Dette skjer:"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:123
msgid "Title"
msgstr "Tittel"

#: src/client/components/AmbassadorsSection/AmbassadorForm.tsx:120
msgid "Title is required"
msgstr "Tittel er påkrevd"

#: src/client/components/ActiveAds/EmptyActiveAds.tsx:68
msgid "Try SmartSearch"
msgstr "Prøv SmartSøk"

#: src/client/components/ImageEditor/ImageEditorModal.tsx:121
msgid "Upload "
msgstr "Last opp "

#: src/client/components/AmbassadorsSection/AmbassadorLogo.tsx:58
msgid "Upload image"
msgstr "Last opp bilde"

#: src/client/components/ImageEditor/ImageCropper.tsx:212
msgid "Upload new image"
msgstr "Last opp nytt bilde"

#: src/client/components/Onboarding/OnboardingEditModal.tsx:53
msgid "Upload or change logo"
msgstr "Last opp eller endre logo"

#: src/client/components/ExtendedProfileForm/LinkRow.tsx:61
msgid "URL"
msgstr "URL"

#: src/client/components/AddSectionButton/AddSectionButton.tsx:44
msgid "Video"
msgstr "Video"

#: src/client/components/StatisticsModal/StatisticsChart.tsx:68
msgid "Visitors per day"
msgstr "Besøkende per dag"

#: src/client/components/EmptyMessage.tsx:34
msgid "Waiting for setup from main account"
msgstr "Venter på oppsett fra hovedkonto"

#: src/client/components/EmptyMessage.tsx:22
msgid "We couldn't find any organizations matching your selected criteria."
msgstr "Vi finner ingen organisasjoner som matcher dine valgte kriterier."

#: src/client/components/Onboarding/OnboardingEditModal.tsx:45
msgid "We have made it easier for you to organize and edit logo and content in the company profile."
msgstr "Vi har gjort det lettere for deg å organisere og redigere logo og innhold i bedriftsprofilen."

#: src/client/api/api.ts:9
msgid "We're having trouble loading this page. Please try again."
msgstr "Vi har problemer med å laste denne siden. Prøv på nytt."

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:40
msgid "When connected, {childName}'s current company profile will be deactivated, and associated profile content will no longer be used."
msgstr "Ved tilknytning, vil {childName} sin nåværende bedriftsprofil bli deaktivert, og tilhørende profilinnhold vil ikke lenger benyttes."

#: src/client/components/ExtendedProfileForm/ExtendedProfileActivationSection.tsx:49
msgid "Yes, activate Extended Profile"
msgstr "Ja, aktiver Tydelig Profil"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:53
msgid "Yes, create connection"
msgstr "Ja, opprett tilknytning"

#: src/client/components/Hierarchy/ConfirmOrgConnectionModal.tsx:61
msgid "Yes, remove connection"
msgstr "Ja, fjern tilknytning"

#: src/client/components/ImageEditor/LogoCheck.tsx:51
msgid "You are ready to publish."
msgstr "Du er klar til å publisere."

#: src/client/components/ImagesSection/ImagesEdit/ImagesEditForm.tsx:108
msgid "You can write an engaging image caption here"
msgstr "Her kan du skrive en fiffig bildetekst"

#: src/client/components/ProfileToolbar/EditModeToolbar.tsx:162
msgid "You have made changes that are not published. If you leave the page now, you will lose these changes."
msgstr "Du har gjort endringer som ikke er publisert. Hvis du forlater siden nå, mister du disse endringene."

#: src/client/components/ExtendedProfileForm/ExtendedProfileModal.tsx:33
msgid "You have made changes that are not saved. If you leave the page now, you will lose these changes."
msgstr "Du har gjort endringer som ikke er lagret. Hvis du forlater siden nå, mister du disse endringene."

#: src/client/components/ActiveAds/EditModeActiveAds.tsx:13
msgid "Your job openings are displayed here "
msgstr "Deres ledige stillinger vises her "
